enum EGrantType {
    CLIENT_CREDENTIALS = 'client_credentials',
}

export default EGrantType
